import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import { CustomSelect, CustomButton, CustomCalendar, CustomModal, CustomReactSelect } from '../../../shared';
import { PlusIcon, Trash, CalendarIcon, Clock } from '../../../../assets';
import routeNames from '../../../../routes/routeNames';
import CreateDataSource from '../createDataSource';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../redux/reducers/dataSourcesReducer';
import { deleteDataSources } from '../../../../redux/thunks/dataSourcesThunk';
import ConfirmationDelete from '../confirmationDelete';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';

const FilterBar = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isNewTrigger, selected } = useSelector(state => state.dataSources);
    const [open, setOpen] = useState(false);
    const { companyOptions, company } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { setCompany } = companyActions;
    
    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    const handleShowModal = () => {
        dispatch(actions.handleNew(isNewTrigger))
    };

    const handleCreateDataSource = () => {
        handleShowModal();
    };

    const handleDataSourceHistory = () => {
        navigate(routeNames.DATA_SOURCES_HISTORY);
    };

    const handleDeleteSelected = () => {
        if(selected.length>0){
            dispatch(deleteDataSources({companyId: company.id, data: {ids: selected}})).then(result => {
                if(result.payload.status_code === 200){
                    dispatch(actions.setSelectAllFalse())
                    onclose();
                }
                
            })
        }
    };

    const onclose = () =>{
        setOpen(!open)
    };
    
    return (
        <>
            <Grid className="flex-row-space-between pb-24px mt-10px">
                <Grid className='d-flex gap-12' xs={6}>
                    {/* Select Inputs */}
                    <Box className="flex-row gap-12"> 
                        <Box width={300}>
                            <CustomReactSelect
                                options={companyOptions}
                                handleFilter={handleCompanyChange}
                                selectedOption={{
                                    label: company.name,
                                    value: company.id,
                                }}
                                customStyle={{ borderRadius: '50px' }}
                                placeholder="Select Company"
                                data_test_id = "datasource_company_selector"
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid xs={6} className='d-flex gap-12'>
                    <CustomButton
                        title="Delete Source"
                        icon={<Trash />}
                        handleClick={()=> setOpen(true)}
                        data_test_id="datasource_delete_button"
                    />
                    <CustomButton
                        title="History"
                        titleColor="#96478D"
                        buttonColor="#F0DBEE"
                        borderColor="#F0DBEE"
                        icon={<Clock color='#8C3F7D' />}
                        handleClick={handleDataSourceHistory}
                        data_test_id="datasource_history_button"
                    />
                    <CustomButton
                        title="Create New"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<PlusIcon color='#FFFFFF' />}
                        handleClick={handleCreateDataSource}
                        data_test_id="datasource_createNew_button"
                    />
                </Grid>
            </Grid>
            <CustomModal
                modalOpen={isNewTrigger}
                component={<CreateDataSource handleClose={handleShowModal} />}
                onClose={handleShowModal}

            />
            <ConfirmationDelete open={open} onClosed={onclose} onConfirms={handleDeleteSelected}/>
        </>
    );
};

export default FilterBar;
